import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { ProductionDataService } from '@shared/services/production-data.service';
import { ProductionTerminalService } from '@shared/services/production-terminal.service';
import { LocalStorageService } from '@shared/services/storage.service';
import { ITerminal, TerminalAdministrationService } from '@shared/services/terminalAdministration.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
	selector: 'app-terminal-station-select',
	templateUrl: './terminal-station-select.component.html',
	styleUrl: './terminal-station-select.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class TerminalStationSelectComponent implements OnDestroy {
	public stationOptions: number[] = [];
	private destroy$: Subject<void> = new Subject<void>();

	constructor(
		public dataService: ProductionDataService,
		public terminalService: ProductionTerminalService,
		public apiTerminalService: TerminalAdministrationService,
		public localStorageService: LocalStorageService,
	) {
		this.terminalService
			.onTerminalChanged()
			.pipe(takeUntil(this.destroy$))
			.subscribe((e) => {
				if (!e) return;
				this.setStationOptions(e);
				this.defaultStationOnInvalidation();
			});

		const terminal = this.terminalService.terminal;
		if (terminal) {
			this.setStationOptions(terminal);
			this.defaultStationOnInvalidation();
		}
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	private setStationOptions(terminal: ITerminal): void {
		// stationFilter = "10" => [1,2,3,4,5,6,7,8,9,10]
		const maxStation = Number.parseInt((terminal?.stationFilter ?? '1').trim(), 10) || 1;
		this.stationOptions = Array.from({ length: maxStation }, (_, index) => index + 1);
	}

	terminalStationSelectionChange(event: MatSelectChange) {
		this.setStation(event.value);
	}

	private setStation(station: number) {
		this.localStorageService.set(`station:${this.terminalService.terminalId}`, `${station}`);
		this.dataService.stationNumber = station;
	}

	private defaultStationOnInvalidation() {
		const cachedStation = Number.parseInt(this.localStorageService.get(`station:${this.terminalService.terminalId}`));
		if (!cachedStation || !this.stationOptions.includes(cachedStation)) {
			this.setStation(1); // 1 is default station
		}
	}
}
